export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const API_ERROR = 'LOGIN_API_ERROR';

export const REQ_DASHBOARD_DATA = "REQ_DASHBOARD_DATA"
export const DASHBOARD_DATA = 'DASHBOARD_DATA';
export const DASHBOARD_DATA_ERROR = 'DASHBOARD_DATA_ERROR';